import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import Tenant from "../entity/Tenant";
import mainStore from "@/store/modules/MainStore";
import formStore from "@/store/modules/FormStore";
import comparatorStore from "@/store/modules/ComparatorStore";
import masterStore from "@/store/modules/MasterStore";
import contractStore from "@/store/modules/ContractStore";
import coreStore from "@/store/modules/CoreStore";
import itemStore from "@/store/modules/ItemStore";
import crmStore from "@/store/modules/CrmStore";

Vue.use(Vuex);
export default new Vuex.Store<any>({
  state: {
    mobileMenuOpen: false,
    mobileAsideOpen: false,
    settings: localStorage.getItem("settings")
        ? JSON.parse(localStorage.getItem("settings")!)
        : null,
  },
  mutations: {
    toggleMobileMenu(state) {
      state.mobileMenuOpen = !state.mobileMenuOpen;
    },
    closeMobileMenu(state) {
      state.mobileMenuOpen = false;
    },
    toggleMobileAside(state) {
      state.mobileAsideOpen = !state.mobileAsideOpen;
    },
    closeMobileAside(state) {
      state.mobileAsideOpen = false;
    },
  },
  modules: {
    mainStore,
    formStore,
    comparatorStore,
    masterStore,
    contractStore,
    coreStore,
    itemStore,
    crmStore,
  },
});
